var _mask, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 130,
    viewBox: "0 0 101 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_24905_12800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4531C0 6.47088 6.47088 0 14.4531 0H86.5469C94.5291 0 101 6.47088 101 14.4531V130H0V14.4531Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4531C0 6.47088 6.47088 0 14.4531 0H86.5469C94.5291 0 101 6.47088 101 14.4531V130H0V14.4531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 14.4531C-1 5.9186 5.9186 -1 14.4531 -1H86.5469C95.0814 -1 102 5.9186 102 14.4531H100C100 7.02317 93.9768 1 86.5469 1H14.4531C7.02317 1 1 7.02317 1 14.4531H-1ZM1 14.4531M101 130H0H101M-1 130V14.4531C-1 5.9186 5.9186 -1 14.4531 -1V1C7.02317 1 1 7.02317 1 14.4531V130H-1ZM86.5469 -1C95.0814 -1 102 5.9186 102 14.4531V130H100V14.4531C100 7.02317 93.9768 1 86.5469 1V-1Z",
    fill: "#171717",
    fillOpacity: 0.07,
    mask: "url(#path-1-inside-1_24905_12800)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1028,
    cy: 19.011,
    r: 6.33714,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 84.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.832,
    cy: 84.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.168,
    cy: 84.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 84.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 104.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.832,
    cy: 104.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.168,
    cy: 104.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 104.5,
    r: 7.5,
    fill: "#171717",
    fillOpacity: 0.1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.095,
    cy: 19.011,
    r: 6.33714,
    fill: "#171717",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 40.748C10.668 36.882 13.802 33.748 17.668 33.748H41.7168C45.5828 33.748 48.7168 36.8821 48.7168 40.748V62.9603C48.7168 66.8263 45.5828 69.9603 41.7168 69.9603H17.668C13.802 69.9603 10.668 66.8263 10.668 62.9603V40.748Z",
    fill: "#2C2768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2852 40.748C52.2852 36.882 55.4192 33.748 59.2852 33.748H83.334C87.2 33.748 90.334 36.8821 90.334 40.748V62.9603C90.334 66.8263 87.2 69.9603 83.334 69.9603H59.2852C55.4192 69.9603 52.2852 66.8263 52.2852 62.9603V40.748Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/light_theme.1eaff0aa168ca9be73cdfd6f7ddb331c.svg";
export { ForwardRef as ReactComponent };